import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../modal.service';
import { MessageBusService, MicroFrontendRouter } from '@xdig/ng-microkernel/micro-frontend';
import { PROJECTS } from '@core/enum/projects.enum';

@Component({
  selector: 'shell-fatca-not-allowed',
  templateUrl: './fatca-not-allowed.component.html',
  styleUrls: ['./fatca-not-allowed.component.scss'],
})
export class FatcaNotAllowedComponent implements OnInit {
  modalError: any;
  constructor(
    public modalService: ModalService,
    public messageBus: MessageBusService,
    public microFrontendRouter: MicroFrontendRouter,
  ) {}

  closeModal() {
    this.modalService.close();
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.modalError = this.messageBus.getValue('shell', 'modal.error');
    });
  }
}
